export default "__VITE_ASSET__DG_KC2u0__"